(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53076],{

/***/ 67255:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin/index2",
      function () {
        return __webpack_require__(90529);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15503);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72211);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31806);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34950);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79794);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_8__);












var firebaseConfig = {
    apiKey: "AIzaSyAOqeao7F5v3sPtmj65yw3hwD78zbz2-AI",
    authDomain: "aiso-api.firebaseapp.com",
    projectId: "aiso-api",
    storageBucket: "aiso-api.appspot.com",
    messagingSenderId: "286868520204",
    appId: "1:286868520204:web:f4f5e812966aef5e129d29",
    measurementId: "G-XD3LEKPFXX"
};
if (firebase_app__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apps.length */ .Z.apps.length === 0) {
    firebase_app__WEBPACK_IMPORTED_MODULE_3__/* ["default"].initializeApp */ .Z.initializeApp(firebaseConfig);
}
var auth = firebase_app__WEBPACK_IMPORTED_MODULE_3__/* ["default"].auth */ .Z.auth();
var SignIn = function() {
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // email, password 값 저장
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("enkinotest@enkino.com"), email = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("123456"), password = ref1[0];
    // const [email, setEmail] = useState("enkinotest@enkino.com");
    // const [password, setPassword] = useState("123456");
    // const [email, setEmail] = useState("er@enkino.com");
    // const [password, setPassword] = useState("123456");
    var signInButtonClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var result, user, email2, name, photo, uid, docs, error, text, text1, text2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            auth.signInWithEmailAndPassword(email, password)
                        ];
                    case 1:
                        result = _state.sent();
                        user = result.user;
                        email2 = user.email;
                        name = "";
                        photo = "";
                        uid = "";
                        docs = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email2));
                        docs.get().then(function(doc) {
                            if (doc.exists) {
                                /* 데이터베이스에서 이름정보 가져오기 */ name = doc.data().name;
                                photo = doc.data().photo;
                                uid = doc.data().id;
                                /* mobx에 저장 & 웹 로컬 스토리지에 로그인 정보 저장 => 토큰 저장하기 */ settings.login = true;
                                settings.email = email2;
                                settings.name = name; // DONE: mobx와 firestore의 필드명 최대한 일치 시키기
                                settings.photo = photo;
                                settings.uid = uid;
                                // const tokenValue = { email: email2, name };
                                var tokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_8__.sign({
                                    email: email2,
                                    name: name,
                                    uid: uid
                                }, "sdkjkdlsAESRcdslkch", {
                                    expiresIn: "1d"
                                });
                                window.localStorage.setItem("aisoToken", tokenValue);
                                router.push("/user/market");
                            } else {
                                var text = "이메일 정보가 없습니다.";
                                (0,components_Alert__WEBPACK_IMPORTED_MODULE_6__/* .BasicAlert */ .N)(text);
                            }
                        }).catch(function(error) {
                            ;
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_6__/* .BasicAlert */ .N)(error);
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if (error.code === "auth/user-not-found") {
                            text = "등록된 이메일이 없습니다.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_6__/* .BasicAlert */ .N)(text);
                            return [
                                2
                            ];
                        }
                        if (error.code === "auth/wrong-password") {
                            text1 = "비밀번호가 일치하지 않습니다.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_6__/* .BasicAlert */ .N)(text1);
                            return [
                                2
                            ];
                        }
                        text2 = "ERROR!";
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_6__/* .BasicAlert */ .N)(text2);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function signInButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center auth pt-5 pb-20",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row w-100 mx-0 h-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-11 col-md-8 col-xl-4 mx-auto py-5 bg-white shadow-sm rounded-3xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-left py-5 px-4 px-sm-5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-center mb-5 font-gmarket-bold font-bold text-primary tracking-widest",
                            children: "LOGIN"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-aaa font-gmarket-medium mb-0 keep-words flex justify-center",
                            children: "아이소 마켓 오픈 전 입니다. 테스트 이메일로 이용해주세요."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: "pt-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Group */ .Z.Group, {
                                    className: "bg-gray-input",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Control */ .Z.Control, {
                                        type: "email",
                                        placeholder: "Email",
                                        size: "lg",
                                        className: "h-auto font-gmarket-medium",
                                        value: "enkinotest@enkino.com",
                                        readOnly: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Group */ .Z.Group, {
                                    className: "bg-gray-input",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Control */ .Z.Control, {
                                        type: "password",
                                        placeholder: "Password",
                                        size: "lg",
                                        className: "h-auto font-gmarket-medium",
                                        value: "123456",
                                        readOnly: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-block btn-primary auth-form-btn font-gmarket-medium",
                                        onClick: function() {
                                            return signInButtonClick();
                                        },
                                        children: "Sign In"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SignIn);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [99499,49774,92888,40179], function() { return __webpack_exec__(67255); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);